import element from './element'
import input from './input'
import recommendation from './recommendation'
import tooltip from './tooltip'

import { COMPETENCES, MATURITY, POTENTIAL } from '@/model/rating/categories'

export default {
    element,
    input,
    recommendation,
    tooltip,

    category: {
        [POTENTIAL]: {
            title: 'Potential',
            subtitle: 'What potential does this trend exploit to us?'
        },
        [MATURITY]: {
            title: 'Maturity',
            subtitle: 'How mature is the trend?'
        },
        [COMPETENCES]: {
            title: 'Competences',
            subtitle: 'How well is your company prepared for this trend?'
        }
    },
    option: {
        low: 'low',
        moderate: 'moderate',
        high: 'high',
        epic: 'very high'
    }
}
